import { ComponentType } from "react";
import DashboardFilterCityBadge from "../../components/Dashboard/filters/City/DashboardFilterCityBadge";
import DashboardFilterCitySheet from "../../components/Dashboard/filters/City/DashboardFilterCitySheet";
import DashboardFilterDateRangeBadge from "../../components/Dashboard/filters/DateRange/DashboardFilterDateRangeBadge";
import DashboardFilterDateRangeSheet from "../../components/Dashboard/filters/DateRange/DashboardFilterDateRangeSheet";
import DashboardFilterEquipmentBadge from "../../components/Dashboard/filters/Equipment/DashboardFilterEquipmentBadge";
import DashboardFilterEquipmentSheet from "../../components/Dashboard/filters/Equipment/DashboardFilterEquipmentSheet";
import DashboardFilterEquipmentCategoryBadge from "../../components/Dashboard/filters/EquipmentCategory/DashboardFilterEquipmentCategoryBadge";
import DashboardFilterEquipmentCategorySheet from "../../components/Dashboard/filters/EquipmentCategory/DashboardFilterEquipmentCategorySheet";
import DashboardFilterEquipmentCategoryUnitForConsumptionBadge from "../../components/Dashboard/filters/EquipmentCategoryUnitForConsumption/DashboardFilterEquipmentCategoryUnitForConsumptionBadge";
import DashboardFilterEquipmentCategoryUnitForConsumptionSheet from "../../components/Dashboard/filters/EquipmentCategoryUnitForConsumption/DashboardFilterEquipmentCategoryUnitForConsumptionSheet";
import DashboardFilterEstablishmentBranchBadge from "../../components/Dashboard/filters/EstablishmentBranch/DashboardFilterEstablishmentBranchBadge";
import DashboardFilterEstablishmentBranchSheet from "../../components/Dashboard/filters/EstablishmentBranch/DashboardFilterEstablishmentBranchSheet";
import DashboardFilterFuelProductsOnlyBadge from "../../components/Dashboard/filters/FuelProductsOnly/DashboardFilterFuelProductsOnlyBadge";
import DashboardFilterFuelProductsOnlySheet from "../../components/Dashboard/filters/FuelProductsOnly/DashboardFilterFuelProductsOnlySheet";
import { DashboardFilterProps, DashboardFilters } from "../../types/dashboards/dashboard.type";

// ATENTION
// when adding a new filter,
// add it in the dependency array of transformedFilters (DashboardComponentContent from DashboardComponent.tsx)

export const dashboardFilters: Record<DashboardFilters, string> = {
  [DashboardFilters.DateRange]: 'Data (início e fim)',
  [DashboardFilters.City]: 'Cidade',
  [DashboardFilters.Equipment]: 'Equipamento',
  [DashboardFilters.EstablishmentBranch]: 'Estabelecimento',
  [DashboardFilters.FuelProductsOnly]: 'Apenas Combustíveis',
  [DashboardFilters.EquipmentCategory]: 'Categoria de equipamento',
  [DashboardFilters.EquipmentCategoryUnitForConsumption]: 'Métrica da categoria',
}

export const dashboardFiltersBadgeComponents: Record<DashboardFilters, ComponentType<DashboardFilterProps>> = {
  [DashboardFilters.DateRange]: DashboardFilterDateRangeBadge,
  [DashboardFilters.City]: DashboardFilterCityBadge,
  [DashboardFilters.Equipment]: DashboardFilterEquipmentBadge,
  [DashboardFilters.EstablishmentBranch]: DashboardFilterEstablishmentBranchBadge,
  [DashboardFilters.FuelProductsOnly]: DashboardFilterFuelProductsOnlyBadge,
  [DashboardFilters.EquipmentCategory]: DashboardFilterEquipmentCategoryBadge,
  [DashboardFilters.EquipmentCategoryUnitForConsumption]: DashboardFilterEquipmentCategoryUnitForConsumptionBadge,
}

export const dashboardFiltersSheetComponents: Record<DashboardFilters, ComponentType<DashboardFilterProps>> = {
  [DashboardFilters.DateRange]: DashboardFilterDateRangeSheet,
  [DashboardFilters.City]: DashboardFilterCitySheet,
  [DashboardFilters.Equipment]: DashboardFilterEquipmentSheet,
  [DashboardFilters.EstablishmentBranch]: DashboardFilterEstablishmentBranchSheet,
  [DashboardFilters.FuelProductsOnly]: DashboardFilterFuelProductsOnlySheet,
  [DashboardFilters.EquipmentCategory]: DashboardFilterEquipmentCategorySheet,
  [DashboardFilters.EquipmentCategoryUnitForConsumption]: DashboardFilterEquipmentCategoryUnitForConsumptionSheet,
}
